import { type InsightWrapperVariant } from "./types";

export function getInsightBackground(variant: InsightWrapperVariant) {
  // FIXME: Automatically disabled during ESLint config update
  // eslint-disable-next-line @typescript-eslint/switch-exhaustiveness-check
  switch (variant) {
    case "shifts-worked": {
      return `linear-gradient(174.67deg, #FF7F8C 5.15%, #F6F3F1 95.73%), #FFFFFF;`;
    }

    case "earnings": {
      return `linear-gradient(174.67deg, #FFBB6C 5.15%, #F6F3F1 95.73%), #FFFFFF;`;
    }

    case "top-workplaces": {
      return `linear-gradient(174.67deg, #DBF5D0 5.15%, #F6F3F1 95.73%), #FFFFFF;`;
    }

    case "patients-helped": {
      return `linear-gradient(174.67deg, #DFE7FF 5.15%, #F6F3F1 95.73%), #FFFFFF;`;
    }

    case "end": {
      return `linear-gradient(174.67deg, #F7CCFF 5.15%, #F6F3F1 95.73%), #FFFFFF;`;
    }

    default: {
      return `linear-gradient(174.67deg, #CCE7FF 5.15%, #F6F3F1 95.73%), #FFFFFF;`;
    }
  }
}
